import { Dialog, DialogContent } from '@/components/ui/dialog';
import { RootState } from '@/redux/store/store';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormMessage,
} from '@/components/ui/form';
import { Label } from '@/components/ui/label';
import { OTPInput } from '@/components/ui/shared/OTPInput/OTPInput';
import PrimaryButton from '@/components/ui/shared/Button/PrimaryButton/PrimaryButton';

const formSchema = z.object({
	otp: z.string().min(6, {
		message: 'Please enter correct information before saving.',
	}),
});

const VerifyOTPPassword = () => {
	const isOpen = useSelector(
		(root: RootState) => root.page.dialog?.type === 'verifyOTP'
	);

	const form = useForm<z.infer<typeof formSchema>>({
		resolver: zodResolver(formSchema),
		defaultValues: {},
	});

	const onSubmit = (value: z.infer<typeof formSchema>) => {
		// Do something with the form values.
		// ✅ This will be type-safe and validated.
		console.log(value);
	};

	return (
		<Dialog open={isOpen}>
			<DialogContent className="max-w-[500px] bg-white">
				<Form {...form}>
					<form
						onSubmit={form.handleSubmit(onSubmit)}
						className="flex flex-col w-full h-full gap-6"
					>
						<h3 className="font-bold text-secondary">Verify OTP</h3>
						<div>
							<p className="text-black">OTP Code has been sent on your email</p>
							<p className="text-black">j*****e@gmail.com</p>
						</div>
						<FormField
							control={form.control}
							name="otp"
							render={({ field }) => {
								return (
									<FormItem>
										<Label>CODE</Label>
										<FormControl>
											<OTPInput {...field}></OTPInput>
										</FormControl>
										<FormMessage />
									</FormItem>
								);
							}}
						/>
						<div className="flex gap-1">
							<p className="text-black">Didn’t get the code.</p>
							<a className="cursor-pointer text-primaryDark hover:underline">
								RESEND CODE
							</a>
						</div>
						<div className="flex w-full gap-4 mx-auto flex-start">
							<PrimaryButton type="submit">VERIFY</PrimaryButton>
						</div>
					</form>
				</Form>
			</DialogContent>
		</Dialog>
	);
};

export default VerifyOTPPassword;
